__turbopack_context__.v({
  "body": "M0qznG_body",
  "mainColumn": "M0qznG_mainColumn",
  "page": "M0qznG_page",
});
